import { render } from "./ListScroll.vue?vue&type=template&id=173d6847&scoped=true"
import script from "./ListScroll.vue?vue&type=script&lang=js"
export * from "./ListScroll.vue?vue&type=script&lang=js"

import "./ListScroll.vue?vue&type=style&index=0&id=173d6847&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-173d6847"

export default script